<script setup lang="ts">
import { computed, reactive } from "vue";
import StopInfoPipForm from "@/views/trips/components/forms/StopInfoPipForm.vue";
import { usePipStore } from "@/store/pip.store";
import { getStopVerifyTitle } from "@/utils/stopInfoTitle";
import type { StopInfoPipProps } from "@/types/props";
import type { RouteStopDto, TripDto, TripRouteDto } from "@/api/trips/dto/trip.dto";

defineOptions({ inheritAttrs: false });

const props = withDefaults(
  defineProps<{
    trip: TripDto;
    route: TripRouteDto;
    stop: RouteStopDto;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "unload"): void;
}>();

const pipStore = usePipStore();

const title = computed<string>(() => getStopVerifyTitle(props.stop));

const pipProps = reactive<StopInfoPipProps>({
  get tripId() {
    return props.trip.id!;
  },
  get route() {
    return props.route;
  },
  get stop() {
    return props.stop;
  },
  get title() {
    return title.value;
  },
});

async function showUnloadVerification(): Promise<void> {
  await pipStore.open({
    component: StopInfoPipForm,
    props: pipProps,
    on: {
      save,
      close: () => pipStore.close(),
    },
  });
}

function save(): void {
  emit("unload");
}
</script>

<template>
  <v-btn
    :disabled="disabled"
    block
    class="text-uppercase font-weight-600"
    color="primary"
    v-bind="$attrs"
    variant="flat"
    @click="showUnloadVerification"
  >
    Unload and verify
  </v-btn>
</template>

<style lang="scss" scoped></style>
